// extracted by mini-css-extract-plugin
module.exports = {"cell":"_1epeSbC28Y","cell-centered":"_2sWnkaRy7m","cellCentered":"_2sWnkaRy7m","cell-small":"_2H_0fWvi6J","cellSmall":"_2H_0fWvi6J","cell-head":"_3Hq1HQO9Zl","cellHead":"_3Hq1HQO9Zl","cell-data":"_3e5Pkue_i6","cellData":"_3e5Pkue_i6"};
    if(module.hot) {
      // 1597843267525
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  